import React from 'react';
import {
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Legend,
    AreaChart,
    Area,
  } from 'recharts';
import { Card, CardContent } from "../../../components/ui/card";
import constants from '../../../commonUtils/constants';


const UserOnboarding = ({ data }) => {
    return (
        <>
            <Card className="shadow-md rounded-2xl col-span-1 md:col-span-2 lg:col-span-3">
                <CardContent>
                    <h2 className="text-lg font-bold mb-4">User Onboarding Over Time</h2>
                    <ResponsiveContainer width="100%" height={300}>
                    <AreaChart data={data}>
                        <defs>
                        <linearGradient id="colorAzure" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor={constants.dashboard.colors[5]} stopOpacity={0.8} />
                            <stop offset="95%" stopColor={constants.dashboard.colors[5]} stopOpacity={0} />
                        </linearGradient>
                        <linearGradient id="colorNonAzure" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor={constants.dashboard.colors[7]} stopOpacity={0.8} />
                            <stop offset="95%" stopColor={constants.dashboard.colors[7]} stopOpacity={0} />
                        </linearGradient>
                        </defs>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Legend />
                        <Area
                            type="monotone"
                            dataKey="azureUsers"
                            stroke={constants.dashboard.colors[5]}
                            fillOpacity={1}
                            fill="url(#colorAzure)"
                            name="Azure Users"
                        />
                        <Area
                            type="monotone"
                            dataKey="nonAzureUsers"
                            stroke={constants.dashboard.colors[7]}
                            fillOpacity={1}
                            fill="url(#colorNonAzure)"
                            name="Non-Azure Users"
                        />
                    </AreaChart>
                    </ResponsiveContainer>
                </CardContent>
            </Card>
        </>
    );
};

export default UserOnboarding;
